import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import inputStyles from "../../../styles/inputs";
import { Button, Menu } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FilterSelect = ({ name, label = "", value, onChange, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onMenuItemClicked = (value) => {
    handleClose();
    onChange({ target: { name, value } });
  };

  let selectedItem = null;
  const dropdownOptions = options.map((option) => {
    if (option.value === value) {
      selectedItem = option;
    }
    return (
      <MenuItem
        key={option.value}
        selected={option.value === value}
        onClick={() => onMenuItemClicked(option.value)}
        value={option.value}
      >
        {option.label}
      </MenuItem>
    );
  });
  return (
    <>
      <Button
        type="button"
        size="small"
        variant="outlined"
        color="secondary"
        style={inputStyles.dropdownFilter}
        onClick={handleClick}
      >
        {value === "all" ? options[0]?.label : selectedItem.label}{" "}
        <ExpandMoreIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ list: { "aria-labelledby": "basic-button" } }}
      >
        {dropdownOptions}
      </Menu>
    </>
  );
};

FilterSelect.propTypes = {};

export default FilterSelect;
